import { injectable } from 'inversify';

import { CreateVacationDto } from '../../dto';

@injectable()
export class VacationCreateFillingMapper {
  processInitialValues(formValues: CreateVacationDto | null) {
    return {
      mustScheduleAllDays: formValues?.mustScheduleAllDays ?? true,
      employeeDeadline: formValues?.employeeDeadline || null,
      mustSchedule14days: formValues?.mustSchedule14days ?? true,
      workingDay: formValues?.workingDay ?? true,
      weekendExclusion: formValues?.weekendExclusion ?? true,
      minDuration: formValues?.minDuration ?? true,
      minDurationUnit: formValues?.minDurationUnit || 'calendar',
      minDurationDays: formValues?.minDurationDays || 1,
      maxDuration: formValues?.maxDuration || false,
      maxDurationDays: formValues?.maxDurationDays || null,
      maxDurationUnit: formValues?.maxDurationUnit || 'calendar',
      limitToCalculatedDays: formValues?.limitToCalculatedDays ?? true,
      allowEmployeeComment: formValues?.allowEmployeeComment || 'true',
      daysMustBeDivisibleBy: formValues?.daysMustBeDivisibleBy || false,
      daysMustBeDivisibleByNumber:
        formValues?.daysMustBeDivisibleByNumber || null,
      companyComment: formValues?.companyComment || '',
      employeeCanSeeVacations: formValues?.employeeCanSeeVacations || 'false',
      teammateAccess: formValues?.teammateAccess || null,
      min5DaysBetweenNotWorkdays:
        formValues?.min5DaysBetweenNotWorkdays ?? true,
      minSpecificWeekendDays: formValues?.minSpecificWeekendDays ?? true,
      validatorGroups: formValues?.validatorGroups || [],
    };
  }
}
